<template>
    <div class="mkt-form-step">

      <md-card-header>
        <md-avatar class="md-avatar-icon step-content-num">1</md-avatar>
        <div class="md-title">Basic Info</div>
      </md-card-header>

      <md-card-content  style="height:calc(100vh - 200px);overflow-y:auto">
        <div class="data-input-step md-layout">
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-80">
                <div class="content-step-data">
                  <md-field class="space-md-field" >
                    <label>Campaign Code</label>
                    <md-input ref="frm_campaign_code" v-model="value.campaign_code" name="campaign_code" id="campaign_code" v-on:keydown="codeHandler($event)"></md-input>
                  </md-field>
                  <!-- <div class="md-error" v-if="true">Name is required</div> -->
                  <md-field class="space-md-field">
                    <label>Campaign Title</label>
                    <md-input ref="frm_campaign_title" v-model="value.campaign_title"></md-input>
                  </md-field>
                  <!-- <div class="md-error" v-if="true">Name is required</div> -->
                  <md-field class="space-md-field">
                    <label>Campaign Detail</label>
                    <!-- <md-input v-model="value.campaign_detail"></md-input> -->
                    <md-textarea v-model="value.campaign_detail" rows="2"></md-textarea>
                  </md-field>
                </div>

                <div class="content-step-data md-layout">
                  <div class="md-layout mkt-datepicker">
                    <div class="md-layout-item">
                      <md-datepicker ref="frm_campaign_start" class="mkt-datepicker-input start" v-model="value.startdate" md-immediately  :md-disabled-dates="disabledDatesStart" @md-opened="checkDate" @md-closed="checkDate">
                        <label>Start Date</label>
                      </md-datepicker>
                      <!-- <div class="md-error" v-if="true">Name is required</div> -->
                    </div>
                  </div>
                  <div class="md-layout mkt-datepicker">
                    <div class="md-layout-item">
                      <md-datepicker ref="frm_campaign_end" class='mkt-datepicker-input end' v-model="value.enddate" md-immediately  :md-disabled-dates="disabledDates">
                        <label>End date</label>
                      </md-datepicker>
                      <!-- <div class="md-error" v-if="true">Name is required</div> -->
                    </div>
                  </div>
                </div>

                <div class="content-step-data md-layout">
                  <div class="md-layout-item md-size-30">
                    <md-field class="space-md-field" >
                      <label>Join Within</label>
                      <md-input ref="frm_campaign_join_within" v-model="value.join_within" name="campaign_join_within" id="campaign_join_within" type="number" min=0 max=90></md-input>
                    </md-field>
                  </div>
                  <div class="md-layout-item md-size-30">
                    <div style="padding-left:20px;padding-top:25px;font-size:16px;">Days</div>
                    </div>
                </div>
            </div>

            

            <!-- <div class="md-layout-item md-size-100">
                <div class="content-step-data">
                  <md-switch v-model="value.campaign_active" class="md-primary">Campaign Active</md-switch>
                </div>
            </div> -->

          </div>
      </div>
      </md-card-content>
      
      <md-dialog-alert
      :md-active.sync="showAlert"
      :md-title="alertTitle"
      :md-content="alertContent" />

  </div>
</template>

<script>
// import { validationMixin } from 'vuelidate'
import moment from "moment-timezone";
import { validationMixin } from 'vuelidate'
  import {
    required,
    email,
    minLength,
    maxLength
  } from 'vuelidate/lib/validators'

export default {
  name: "campaign-step1",
  props:['value'],
  watch:{

  },
  data(){
    return {
      campaign_code: "",
      campaign_title:"",
      campaign_detail: "",
      campaign_active: "",
      startdate: "",
      enddate:"",
      showAlert: false,
      alertTitle: "Alert",
      alertContent: "",
      disabledDates: date => {
        //const day = date.getDay()

        return date < this.value.startdate

        //return day === 6 || day === 0
      },
      disabledDatesStart: date =>{
        return date < moment().add(-1, 'days');//Date.now();
      }

    }
  },
  validations: {
    form: {
        campaign_code: {
          required,
        }
    }
  },
  methods: {
    clearForm () {
        this.$v.$reset()
        this.form.campaign_code = null
      },
    getValidationClass (fieldName) {
        const field = this.$v.form[fieldName]

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty
          }
        }
      },
    codeHandler(e){
      if(e.keyCode==32){
        e.preventDefault();
      }
    },
    checkDate(){
      //alert('check date')
      if(this.value.startdate > this.value.enddate)
        if(this.value.enddate != null)
          this.value.enddate = this.value.startdate;
    },
    isValidate(){
      if(!this.value.campaign_code){
        // alert('Please input code.');
        this.showAlert = true;
        this.alertContent = "Please input code.";
        this.$refs.frm_campaign_code.$el.focus();
        return false;
      }
      if(!this.value.campaign_title){
        this.showAlert = true;
        this.alertContent = "Please input title.";
        this.$refs.frm_campaign_title.$el.focus();
        return false;
      }
      if(!this.value.startdate){
        this.showAlert = true;
        this.alertContent = "Please select start date.";
        //  this.$refs.frm_campaign_start.$el.focus();
        return false;
      }
      if(!this.value.enddate){
        this.showAlert = true;
        this.alertContent = "Please select end date.";
        //  this.$refs.frm_campaign_end.$el.focus();
        return false;
      }
      // if(this.value.join_within == ""){
      //   this.showAlert = true;
      //   this.alertContent = "Please input join within.";
      //   //  this.$refs.frm_campaign_end.$el.focus();
      //   return false;
      // }
      return true;
    }
  }
}

</script>

<style lang="scss">

.md-datepicker-dialog {
  .md-datepicker-today{
    font-size:16px;
    color: rgb(85, 85, 85) !important;
  }

  .md-datepicker-selected{
    font-size:16px;
    // color:white !important;
  }
}
</style>

<style lang="scss" scoped>


.content-step-data {
  .space-md-field {
    margin-bottom: 4px;
  }
}

.md-card-header {
  height: 70px;
  .md-title {
    padding-top: 10px;
    font-size: 18px;
  }
}

.md-error{
  color:red;
  font-size:12px;
}
.star{
  color:red;
}

.md-textarea{
  min-height:70px !important;
}

</style>